// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  font-family: 'Roboto', sans-serif;
  min-height: calc(100vh - 100px);
  padding-bottom: 100px;
}

.home-content {
  width: 80%;
  max-width: 800px;
  text-align: center;
  margin-top: 90px;
  margin-bottom: 100px;
}

.welcome-image {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 56%;
  max-width: 100%;
  height: auto; 
  max-height: 80%;
  z-index: -1;
  margin-top: 20px;
}

.home-content h1 {
  font-size: 55px;
  color: #047da2;
  margin-bottom: 20px;
}

.home-content p {
  font-size: 20px;
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .home-content h1 {
    font-size: 35px;
  }

  .home-content {
    width: 90%;
    margin-top: 70px;
  }

  .welcome-image {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    max-width: 100%;
    height: auto; 
    max-height: 80%;
    z-index: -1;
    margin-top: 10px;
  }

  .home-content p {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,eAAe;EACf,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".home-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  font-family: 'Roboto', sans-serif;\n  min-height: calc(100vh - 100px);\n  padding-bottom: 100px;\n}\n\n.home-content {\n  width: 80%;\n  max-width: 800px;\n  text-align: center;\n  margin-top: 90px;\n  margin-bottom: 100px;\n}\n\n.welcome-image {\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 56%;\n  max-width: 100%;\n  height: auto; \n  max-height: 80%;\n  z-index: -1;\n  margin-top: 20px;\n}\n\n.home-content h1 {\n  font-size: 55px;\n  color: #047da2;\n  margin-bottom: 20px;\n}\n\n.home-content p {\n  font-size: 20px;\n  margin-bottom: 30px;\n}\n\n@media (max-width: 768px) {\n  .home-content h1 {\n    font-size: 35px;\n  }\n\n  .home-content {\n    width: 90%;\n    margin-top: 70px;\n  }\n\n  .welcome-image {\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: auto;\n    max-width: 100%;\n    height: auto; \n    max-height: 80%;\n    z-index: -1;\n    margin-top: 10px;\n  }\n\n  .home-content p {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
